import type { EntityOptions } from 'typeorm';
import { Entity as TypeOrmEntity } from 'typeorm';

export interface CustomEntityMetadata {
	label?: string;
	isDvpTable?: boolean;
}

const customEntityMetadataStorage = new Map<
	string,
	CustomEntityMetadata & { target: Function }
>();

export function Entity(
	options?: EntityOptions,
	customOptions?: CustomEntityMetadata,
): ClassDecorator;
export function Entity(
	name?: string,
	options?: EntityOptions,
	customOptions?: CustomEntityMetadata,
): ClassDecorator;
export function Entity(
	...params: Array<string | EntityOptions | CustomEntityMetadata | undefined>
): ClassDecorator {
	let customOptions: CustomEntityMetadata | undefined;

	if (
		params.length === 3 ||
		(params.length === 2 && typeof params[0] === 'object')
	) {
		customOptions = params.pop() as CustomEntityMetadata;
	}

	return (target: Function) => {
		customEntityMetadataStorage.set(target.name, {
			target,
			...customOptions,
		});

		TypeOrmEntity(...(params as [EntityOptions]))(target);
	};
}

// Helper to retrieve custom metadata
export function getCustomEntityMetadata(
	entityClass: Function,
): CustomEntityMetadata | undefined {
	return customEntityMetadataStorage.get(entityClass.name);
}
